import * as React from 'react';
export const bannerbankSvg = React.forwardRef(function bannerbankSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#004FA2',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5 18.34c1.606-.08 4.26.457 6 1.66l5.365-1.68C17.5 13.388 19.596 8.82 25 5 7.875 9.164 5 18.34 5 18.34Z',
      fill: '#FFC937',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6 18.927c3.907-.176 9.662 3.777 10.5 8.073 1.242-7.809 1.726-15.266 10.5-21C9.019 10.032 6 18.927 6 18.927Z',
      fill: '#EE3A41',
    }),
  );
});
bannerbankSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var bannerbank = {
  category: 'brand',
  colorable: false,
  name: 'bannerbank',
  svg: bannerbankSvg,
};
